<template>
  <div style="min-height: 100vh">
    <van-loading type="spinner" v-if="nodata"/>
    <div style="background: #A80034;">
      <div class="logo" v-if="dominItem.templateId === 'temp2'">
        <div style="display: flex; align-items: center; gap: 50px">
          <span style="margin-left: 30px">{{ dominItem.logoName || 'Logo' }}</span>
          <div class="category" >
            <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
                item.label
              }}</span>
          </div>
        </div>
        <topIcon :template="dominItem.templateId" :nationId="dominItem.nationId" color="#A80034"></topIcon>
      </div>

      <div class="logo" v-if="dominItem.templateId === 'temp3'">
        <span style="margin-left: 30px">{{ dominItem.logoName || 'Logo' }}</span>
        <div class="category" >
          <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
              item.label
            }}</span>
        </div>
        <topIcon :template="dominItem.templateId" :nationId="dominItem.nationId" color="#A80034"></topIcon>
      </div>

      <div class="logo" v-if="dominItem.templateId === 'temp1'">

        <div class="category" style="display: flex">
          <topIcon :template="dominItem.templateId" :nationId="dominItem.nationId" color="#A80034"></topIcon>
          <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
              item.label
            }}</span>
        </div>
        <span style="margin-right: 30px">{{ dominItem.logoName || 'Logo' }}</span>
      </div>

    </div>

    <div style="width: 1500px; margin: auto">
      <div class="baseball-article-page">
        <!-- 文章主体部分 -->
        <div class="article-main">

          <img
              v-if="bestInfo.articleImage"
              :src="bestInfo.articleImage"
              class="article-img" style="height: 400px"
          />

          <h1 class="article-title">{{ bestInfo.articleTitle }}</h1>

          <span class="time">
          <img src="@/assets/icon/time_fill.png" alt="">
        <span style="margin-left: 20px">{{ bestInfo.uploadTime }}</span>
        <img src="@/assets/icon/eyess.png" style="margin-left: 20px" alt="">
        <span class="number">{{ bestInfo.articleReadNum }}</span>
      </span>
          <div class="article-meta">
            <img v-if="dominItem.templateId === 'temp1'" src="@/assets/temp1.jpg" alt="" class="author-logo"/>
            <img v-if="dominItem.templateId === 'temp2'" src="@/assets/temp2.jpg" alt="" class="author-logo"/>
            <img v-if="dominItem.templateId === 'temp3'" src="@/assets/temp3.jpg" alt="" class="author-logo"/>
            <div class="meta-info">
              <span class="author">{{ bestInfo.updateBy || $t('con_Editor') }}</span>
              <span class="publish-date">{{ bestInfo.uploadTime }}</span>
            </div>
          </div>

          <p class="photo-credit">{{ bestInfo.articleTitle }}</p>

          <div style="margin-top: 30px; text-align: center" v-for="item in videoList">
            <video ref="videoRef" :src="item.url" width="650" height="400" controls ></video>
          </div>
          <div class="detail" style="margin-bottom: 20px" v-html="bestInfo.articleContent"></div>
        </div>


        <!-- 最新文章侧边栏 -->
<!--        <div class="sidebar">-->
<!--          <h2 class="sidebar-title">{{ $t('con_hot_con') }}</h2>-->
<!--          <div class="latest-post" v-for="item in latestNewsList" @click="toDetail(item.articleShortName)">-->
<!--            <img-->
<!--                :src="item.articleImage"-->
<!--                class="article-img"-->
<!--            >-->
<!--            <h3 class="twoHde" style="margin-left: 0">{{ item.articleTitle }}</h3>-->
<!--            <p class="threeHde" style="color: #A80034; margin-left: 0">{{ item.uploadTime }}</p>-->
<!--          </div>-->
<!--        </div>-->
      </div>

      <buttomIcon v-if="dominItem.nationId !== 'cn'" style="width: 1500px; margin: 40px auto"></buttomIcon>

    </div>
    <div class="buttom">
      <div class="kuai">
        <div class="btn-logo">{{ dominItem.logoName || 'Logo' }}
          <div style="display: flex; align-items: center">
            <img class="imgsss" v-if="dominItem.nationId !== 'cn'" v-for="item in iconListsmall" @click="openLink(item.link)" :src="item.url" alt="">
          </div>
        </div>
        <div class="explore">
          <span v-for="item in typeList" @click="changeType(item.id)" style="cursor: pointer; color: #ffffff">{{ item.label }}</span>
        </div>
        <footers is00="is04" color="#ffffff" widd="none" style="border-top: 1px solid #fff"
                 :articleListlast="articleListlast" :current="current"></footers>
      </div>
    </div>
  </div>
</template>

<script>
import {format} from "date-fns";
import whileIcon from "@/components/icons/whileicon.vue"
import topIcon from "@/components/icons/small.vue";
import footers from "@/components/footContent/index.vue"
import {getContentList, getInfo, getLatestNews} from "@/api";
import {Base64} from "js-base64";
import buttomIcon from "@/components/icons/big.vue";

export default {
  name: "index",

  props: {
    dominItem: Object
  },

  components: {buttomIcon, topIcon, whileIcon, footers},
  data() {
    return {
      bestInfo: {},
      articleListlast: [],
      latestNewsList: [],
      template: 'temp1',
      nowDate: undefined,
      current: 1,
      nodata: false,
      iconListsmall: [
        {url: require('../../../assets/icon/linkedin.png'), link: 'https://www.linkedin.cn/'},
        {url: require('../../../assets/icon/facebook.png'), link: 'https://www.facebook.com/'},
        {url: require('../../../assets/icon/flipboard.png'), link: 'https://www.flipboard.cn/'},
        {url: require('../../../assets/icon/twitter.png'), link: 'https://twitter.com/'},
        {url: require('../../../assets/icon/instagram.png'), link: 'https://www.instagram.com/'},
      ],
      typeList: [
        {label: this.$t('con_AllPRESS'), id: 4},
        {label: this.$t('con_home'), id: 1},
        {label: this.$t('con_AUTO'), id: 6},
        {label: this.$t('con_NEWS'), id: 3},
        {label: this.$t('con_BUSINESS'), id: 2},
        {label: this.$t('con_TECHNOLOGY'), id: 7},
        {label: this.$t('con_LIFESTYLE'), id: 5},
      ],
    }
  },
  created() {
    this.current = Number(this.$route.query.type)
    this.nowDate = format(new Date(), this.$t('con_format'))

    this.nationId = JSON.parse(localStorage.getItem('dominItem')).nationId
    this.domainName = JSON.parse(localStorage.getItem('dominItem')).domainName

    this.getArticleListlast()
    this.getLatestNewsList()
    this.getPageInfo(this.$route.params.name)
  },
  methods: {
    openLink(link) {
      window.open(link)
    },
    changeType(item) {
      if (item === 8) {
        item = 1
      }
      this.$router.push(`/?type=${item}`)
    },

    toDetail(name) {
      this.$router.push(`/details/${name}?type=${this.current}`)
    },

    // 根据文章id获取文章详情
    getPageInfo(name) {
      this.nodata = true
      getInfo({name: name, articleNationId: this.nationId, domain: this.domainName}).then(res => {
        let Base64 = require('js-base64').Base64;
        this.bestInfo = res.data.articleInfo
        this.bestInfo.uploadTime = format(new Date(this.bestInfo.uploadTime), this.$t('con_format'))
        this.bestInfo.articleContent = Base64.decode(this.bestInfo.articleContent);
        this.nextChapter = res.data.nextChapter
        this.videoList = JSON.parse(this.bestInfo.remark)
        this.previousPost = res.data.previousPost
        this.recommendArticle = res.data.recommendArticle
        this.nodata = false
        this.bestInfo.articleImage = this.bestInfo.articleImage ? this.bestInfo.articleImage :
            JSON.parse(localStorage.getItem('dominItem')).defaultImg

      })
    },

    // 获取最下面文章列表
    getArticleListlast() {
      // this.nodata = true
      getContentList({
        articleCategoryId: 1,
        pageNum: 1,
        pageSize: 4,
        articleNationId: this.nationId
      }).then(res => {
        this.articleListlast = res.rows
        this.nodata = false
      })
    },

    // 获取最后次更新的文章
    getLatestNewsList() {
      getLatestNews({
        articleCategoryId: 1,
        pageNum: this.newsPageNum,
        pageSize: 6,
        articleNationId: this.nationId
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })


        this.latestNewsList = res.rows
        this.newsTotal = res.total
      })
    },
  }
};
</script>

<style scoped lang="scss">
.baseball-article-page {
  width: 1500px;
  margin: auto;
  display: flex;
  gap: 30px;
  padding: 20px 0;

  .article-main {
    flex: 1;

    .article-title {
      font-size: 28px;
      font-weight: bold;
      margin-bottom: 10px;
    }

    .article-meta {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      .author-logo {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 10px;
      }

      .meta-info {
        .author {
          font-weight: bold;
          display: block;
        }

        .publish-date {
          font-size: 14px;
        }
      }
    }


    .photo-credit {
      font-size: 12px;
      color: #999;
      margin-bottom: 20px;
    }

    .article-content {
      line-height: 1.6;
    }
  }

  .sidebar {
    width: 300px;

    .sidebar-title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 15px;
      padding: 5px 10px;
      border-radius: 5px;
      color: #ffffff;
      background: #A80034;
    }

    .latest-post {
      margin-bottom: 20px;

      .post-thumbnail {
        width: 100%;
        height: auto;
        margin-bottom: 10px;
      }

      .post-title {
        font-size: 16px;
        margin-bottom: 5px;
      }

      .post-date {
        font-size: 14px;
        color: #666;
      }
    }
  }
}


.logo {
  width: 1500px;
  margin: 0 auto;
  padding: 10px 0;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  font-size: 20px;
  color: #ffffff;

  justify-content: space-between;
  font-weight: bold;
  text-align: left;
}

.logo-temp1 {
  padding: 0 20px 0 10%;
}

.logo-temp2 {
}

.category {
  min-height: 40px;
  //margin-bottom: 30px;
  color: #ffffff;
  font-weight: 700;
  //border-top: 2px solid var(--themeColor);
  //border-bottom: 2px solid #E6E8EA;
  line-height: 38px;

  span {
    font-weight: 500;
    font-size: 17px;
    display: inline-block;
    padding: 0 10px;
    cursor: pointer;
    position: relative;
    //border-bottom: 3px solid #ffffff;
  }

  span:hover {
    color: #8A898A;
    //border-bottom: 3px solid #013497;
    transition: all .1s ease;
    background: #F9F9F9;
    border-radius: 5px;
    //border-bottom: 3px solid #E2001A;
  }

  .choose {
    transition: all .1s ease;
    color: #A80034;
    border-radius: 5px;
    background: #F9F9F9;
    //border-bottom: 3px solid #013497;
  }
}

.buttom {
  background: #000000;
  display: flex;
  padding-top: 30px;
  flex-direction: column;

  .kuai {
    //width: 1260px;
    padding: 0 calc(10% - 20px) 0 calc(10% - 40px);
    margin: auto;
  }

  .btn-logo {
    margin-left: 50px;
    font-size: 40px;
    color: #ffffff;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: transparent;
  }
  .explore {
    display: flex;
    margin-left: 50px;
    margin-top: 30px;
    margin-bottom: 20px;
    align-items: center;
    font-weight: bold;
    span {
      margin-right: 10px;
      font-size: 15px;
    }
  }
}

.about {
  cursor: pointer;
  height: 40px;
  line-height: 40px;
  font-weight: 400;
  font-size: 17px;
  text-transform: uppercase;
  display: flex;
  justify-content: end;
  //justify-content: space-between;
  padding-right: 20px;
  color: #ffffff;
  background: #000000;
  align-items: center;

  span {
    margin-left: 20px;
    margin-right: 20px;
  }

  img {
    width: 20px;
    height: 20px;
  }

  img:nth-child(4) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(5) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(6) {
    width: 30px;
    height: 30px;
  }
}


.content {
  display: flex;
  flex-wrap: wrap;

  span {
    display: inline-block;
    margin-bottom: 10px;
    width: 50%;
  }
}


.imgsss {
  width: 30px;
  height: 30px;
}

.imgsss:nth-child(4) {
  width: 40px;
  height: 40px;
}

.imgsss:nth-child(5) {
  width: 40px;
  height: 40px;
}

.imgsss:nth-child(3) {
  width: 40px;
  height: 40px;
}

.article-image1 {
  width: 80px;
  height: 80px;
  object-fit: cover;
}
.bgSpan {
  color: #ffffff;
  border-radius: 5px;
  border: 1px solid red;
  display: inline-block;
  padding: 5px 10px;
  background: #E2001A;
}


.time {
  color: rgba(0, 0, 0, .44);
  margin: 10px 0 20px;
  white-space: nowrap;
  line-height: 26px;
  font-weight: 400;
  font-size: 18px;
  align-items: center;
  display: flex;

  span:last-child {
    font-weight: 700;
    color: #4d4d4d;
    margin-left: 10px;
  }

  img {
    height: 20px;
  }
}

.detail {
  font-weight: 400;
  line-height: 32px;
  font-size: 18px;
  color: #222222;
  margin-top: 20px;
}

.article-img {
  width: 100%;
  height: 150px;
  object-fit: cover;
  margin-bottom: 10px;
}
</style>